export enum PopupState {
  INITIAL = 'INITIAL', // Popup just created
  LOADING = 'LOADING', // Popup is loading its content
  READY = 'READY', // Popup has loaded and is ready
  BLOCKED = 'BLOCKED', // Popup was blocked by browser
  ERROR = 'ERROR', // Popup encountered an error
  CLOSED = 'CLOSED', // Popup was closed by user
  COMPLETED = 'COMPLETED', // Popup completed its task successfully
}

export interface PopupDimensions {
  width: number;
  height: number;
}

export interface PopupConfig extends PopupDimensions {
  name?: string;
  resizable?: boolean;
  scrollbars?: boolean;
}

export interface PopupEventHandlers {
  onReady?: (popup: Window) => void | Promise<void>;
  onBlocked?: () => void;
  onError?: (error: Error) => void;
  onClosed?: () => void;
  onCompleted?: () => void;
}

export type PopupStateHandler = (
  popup: Window,
  state: PopupState,
  error?: Error
) => void | Promise<void>;

export const DEFAULT_CONFIG: Required<PopupConfig> = {
  width: 500,
  height: 600,
  name: 'popup',
  resizable: true,
  scrollbars: true,
};
